import validator from './validator';
import moment from 'moment-timezone';

const NUMERIC_REGEX = /^\d+$/;
const DATE_REGEX = /^\d{2}\/\d{2}\/\d{4}$/;

export const isNumericInput = (value) => NUMERIC_REGEX.test(value);
export const isIdSearch = (value, maxDigits) => isNumericInput(value) && value.length <= maxDigits;
export const isDocumentSearch = (value, maxDigits) => isNumericInput(value) && value.length > maxDigits;
export const isEmailSearch = (value) => validator.isEmail(value);
export const isDateSearch = (value) => DATE_REGEX.test(value) && moment(value, 'DD/MM/YYYY', true).isValid();
export const parseDateToRange = (value) => {
    const date = moment(value, 'DD/MM/YYYY');
    return {
        startAt: date.startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
        endAt: date.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
    };
};
